var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCenterDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E2E5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3642 19.6262C28.3642 22.8488 25.7725 26.6635 20.5988 31.0801C15.4252 26.6635 12.8335 22.8488 12.8335 19.6262C12.8335 14.7923 16.522 11.6667 20.5988 11.6667C24.6756 11.6667 28.3642 15.5408 28.3642 19.6262ZM20.5983 22.3442C22.2065 22.3442 23.5103 21.0404 23.5103 19.4322C23.5103 17.8239 22.2065 16.5202 20.5983 16.5202C18.99 16.5202 17.6863 17.8239 17.6863 19.4322C17.6863 21.0404 18.99 22.3442 20.5983 22.3442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCenterDefault);
export default __webpack_public_path__ + "static/media/icon_center_default.09eed24556ae6eb31181694bacf4677b.svg";
export { ForwardRef as ReactComponent };